import { createAppWrap } from '../../create_app_wrap';
import commonMixin from '../../mixins/_common';
import setupMixin from './mixin';
import modalMixin from '../../mixins/_modal';
import chromeExtensionMixin from '../../mixins/_chrome_extension';

const view = '[data-view="setup-confirm"]';
const init = () => {
    /**

     * Vueオブジェクト
     * @type {Vue|any}
     */
    createAppWrap({
        el: view,
        mixins: [
            commonMixin,
            setupMixin,
            chromeExtensionMixin,
        ],
        components: {
            // 反映エラーモーダル
            'deploy-error': {
                mixins: [modalMixin]
            }
        },
        methods: {
            // 拡張機能完了時処理
            finish: function () {
                this.locationHref(this.nextPage);
            }
        }
    });
};

if (document.querySelector(view)) {
    init();
}
